import { QRCodeSVG } from 'qrcode.react';
import CopyToClipboard from 'react-copy-to-clipboard';
import ReactTooltip from 'react-tooltip';
import { useRef } from 'react';
import liff from '@line/liff';
import link from '../assets/link.png';
import share from '../assets/share.png';
import { useTranslation } from 'react-i18next';

export default function InvitationPage({ inviteUrl }: { inviteUrl: string }) {
  const [t] = useTranslation(['chatroom']);
  const copiedRef = useRef<any>();
  const sharedRef = useRef<any>();

  const onShareClick = () => {
    liff
      .shareTargetPicker([
        {
          type: 'text',
          text: `${t(
            'share_chatroom_liff_text',
            '加入我的活動工作群吧！{{inviteUrl}}',
            {
              inviteUrl: inviteUrl,
            }
          )}`,
        },
      ])
      .then((res) => {
        if (!sharedRef || !res) {
          return;
        }

        if (res.status) {
          ReactTooltip.show(sharedRef.current);
          setTimeout(() => {
            ReactTooltip.hide(sharedRef.current);
          }, 1500);
        }
      });
  };

  const onCopyClick = () => {
    if (!copiedRef) {
      return;
    }
    ReactTooltip.show(copiedRef.current);
    setTimeout(() => {
      ReactTooltip.hide(copiedRef.current);
    }, 1000);
  };
  return (
    <div className="bg-white flex flex-col p-4 w-full items-center gap-y-5">
      <QRCodeSVG size={192} value={inviteUrl || ''}></QRCodeSVG>
      <p className="text-[#333333] whitespace-pre text-center">
        {t(
          'share_chatroom_title',
          '顯示或發送行動條碼給組員\n邀請加入並持續進行活動'
        )}
      </p>
      <div className="flex w-full justify-center gap-16">
        <CopyToClipboard text={inviteUrl || ''} onCopy={onCopyClick}>
          <div className="flex flex-col items-center">
            <img
              ref={copiedRef}
              data-for="copyTooltip"
              data-tip="copied!"
              alt="copy link"
              src={link}
            ></img>
            <span className="text-xs text-[#222222] mt-2">
              {t('share_chatroom_copy_link', '複製連結')}
            </span>
            <ReactTooltip id="copyTooltip" />
          </div>
        </CopyToClipboard>
        <div className="flex flex-col items-center" onClick={onShareClick}>
          <img
            ref={sharedRef}
            data-for="shareTooltip"
            data-tip="shared!"
            data-event="none"
            alt="share"
            src={share}
          ></img>
          <span className="text-xs text-[#222222] mt-2">
            {t('share_chatroom_share', '分享')}
          </span>
          <ReactTooltip id="shareTooltip" />
        </div>
      </div>
    </div>
  );
}
